<template>
  <div class="users-merge-block mb-6">
    <v-btn block depressed :ripple="false" color="#f8f9fb" class="rounded-0" @click="cancelMerge" :disabled="mergeLoading">
      <v-icon size="30">icon-chevron-up</v-icon>
    </v-btn>
    <div class="pa-6">
      <v-form ref="mergeForm" v-model="formValid" class="users-merge-block__scroll-area">
        <div class="users-merge-block__row">
          <div class="users-merge-block__input-holder text-center"/>
          <div class="users-merge-block__options-row">
            <div v-for="user in mergeData" class="users-merge-block__option-holder text-center">
              <v-btn icon @click="deleteMergeUser(user)">
                <v-icon size="25">mdi-close-thick</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
        <div class="users-merge-block__row">
          <div class="users-merge-block__input-holder text-center">
            <span class="font-weight-bold">Resultat - Hevisere info</span>
          </div>
          <div class="users-merge-block__options-row">
            <div v-for="(user, index) in mergeData" class="users-merge-block__option-holder text-center">
              <v-btn color="primary" outlined @click="setOptionsValue(index)">Klik alle af</v-btn>
            </div>
          </div>
        </div>
        <div class="users-merge-block__row">
          <div class="users-merge-block__input-holder">
            <v-text-field v-model="userName" label="Brugernavn*" :rules="[rules.required]" @input="resetOptionValue('userNameRow')" readonly hide-details outlined/>
          </div>
          <UsersMergeOption ref="userNameRow" :mergeData="mergeData" keyName="userName" @changeValue="changeResultValue('userName', $event)"/>
        </div>
        <div class="users-merge-block__row">
          <div class="users-merge-block__input-holder">
            <v-text-field v-model="firstName" label="Fornavn*" :rules="[rules.required]" @input="resetOptionValue('firstNameRow')" hide-details outlined/>
          </div>
          <UsersMergeOption ref="firstNameRow" :mergeData="mergeData" keyName="firstName" @changeValue="changeResultValue('firstName', $event)"/>
        </div>
        <div class="users-merge-block__row">
          <div class="users-merge-block__input-holder">
            <v-text-field v-model="lastName" label="Efternavn*" :rules="[rules.required]" @input="resetOptionValue('lastNameRow')" hide-details outlined/>
          </div>
          <UsersMergeOption ref="lastNameRow" :mergeData="mergeData" keyName="lastName" @changeValue="changeResultValue('lastName', $event)"/>
        </div>
        <div class="users-merge-block__row">
          <div class="users-merge-block__input-holder">
            <v-text-field v-model="email" label="Email*" :rules="[rules.required, rules.email]" @input="resetOptionValue('emailRow')" hide-details outlined/>
          </div>
          <UsersMergeOption ref="emailRow" :mergeData="mergeData" keyName="email" @changeValue="changeResultValue('email', $event)"/>
        </div>
        <div class="users-merge-block__row">
          <div class="users-merge-block__input-holder">
            <v-text-field v-model="phone" label="Telefon" @input="resetOptionValue('phoneRow')" hide-details outlined/>
          </div>
          <UsersMergeOption ref="phoneRow" :mergeData="mergeData" keyName="phone" @changeValue="changeResultValue('phone', $event)"/>
        </div>
        <div class="users-merge-block__row">
          <div class="users-merge-block__input-holder">
            <v-text-field v-model="mobilePhone" label="Mobil" @input="resetOptionValue('mobileRow')" hide-details outlined/>
          </div>
          <UsersMergeOption ref="mobileRow" :mergeData="mergeData" keyName="mobilePhone" @changeValue="changeResultValue('mobilePhone', $event)"/>
        </div>
        <div class="users-merge-block__row">
          <div class="users-merge-block__input-holder">
            <v-select v-model="status" :items="statusItems" :rules="[rules.requiredId]" item-text="value" item-value="key" label="Status*" @change="resetOptionValue('statusRow')" hide-details outlined/>
          </div>
          <UsersMergeOption ref="statusRow" :mergeData="mergeData" keyName="status" @changeValue="changeResultValue('status', $event)"/>
        </div>
        <div class="users-merge-block__row">
          <div class="users-merge-block__input-holder">
            <v-text-field v-model="dentistExternalId" label="Henviser id" hide-details outlined @input="resetOptionValue('dentistExternalIdRow')"/>
          </div>
          <UsersMergeOption ref="dentistExternalIdRow" :mergeData="mergeData" keyName="dentistExternalId" @changeValue="changeResultValue('dentistExternalId', $event)"/>
        </div>
        <div class="users-merge-block__row">
          <div class="users-merge-block__input-holder">
            <v-text-field v-model="ediDentistId" label="EDI Henviser id" @input="resetOptionValue('ediDentistIdRow')" hide-details outlined/>
          </div>
          <UsersMergeOption ref="ediDentistIdRow" :mergeData="mergeData" keyName="ediDentistId" @changeValue="changeResultValue('ediDentistId', $event)"/>
        </div>
        <div class="users-merge-block__row">
          <div class="users-merge-block__input-holder">
            <v-checkbox :class="['my-0', 'py-0']" v-model="isSecretary" label="Tandlæge sekretær" @change="resetOptionValue('isSecretaryRow')" hide-details />
          </div>
          <UsersMergeOption ref="isSecretaryRow" :mergeData="mergeData" keyName="isSecretary" @changeValue="changeResultValue('isSecretary', $event)"/>
        </div>
        <div class="users-merge-block__row">
          <div class="users-merge-block__input-holder">
            <v-checkbox :class="['my-0', 'py-0']" v-model="sendEndingLettersViaEDI" label="Send Udskrivningsbrev via EDI" @change="resetOptionValue('sendEndingLettersViaEDIRow')" hide-details />
          </div>
          <UsersMergeOption ref="sendEndingLettersViaEDIRow" :mergeData="mergeData" keyName="sendEndingLettersViaEDI" @changeValue="changeResultValue('sendEndingLettersViaEDI', $event)"/>
        </div>
      </v-form>
      <div class="d-flex justify-center mt-6">
        <v-btn color="primary" @click="saveMerge" :loading="mergeLoading" :disabled="mergeLoading">Gem "fusioneringen"</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import UsersMergeOption from '@/components/users/UsersMergeOption.vue';
  import validationRules from '@/utils/validationRules';
  import api from '@/api/api';
  import methods from '@/utils/methods';

  export default {
    name: 'UsersMergeDialog',

    components: {UsersMergeOption},

    props: {
      mergeData: {
        type: Array,
      },
      filterParams: {
        type: Object
      },
      queryParams: {
        type: Object
      }
    },

    data: function() {
      return {
        rules: {...validationRules},
        formValid: false,
        mergeDialog: false,
        mergeLoading: false,
        userName: '',
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        mobilePhone: '',
        status: null,
        isSecretary: false,
        dentistExternalId: null,
        sendEndingLettersViaEDI: false,
        ediDentistId: '',
      }
    },

    computed: {
      statusItems: function() {
        return this.$store.state.users.statusItems;
      }
    },

    watch: {
      mergeData: function() {
        this.resetData();
        this.setOptionsValue(null);
        this.$refs.mergeForm.reset();
      }
    },

    methods: {
      changeResultValue: function(key, value) {
        this[key] = value;
      },
      deleteMergeUser: function(user) {
        this.$emit('deleteMergeUser', user);
      },
      resetData: function() {
        this.userName = '';
        this.firstName = '';
        this.lastName = '';
        this.email = '';
        this.phone = '';
        this.mobilePhone = '';
        this.status = null;
        this.isSecretary = false;
        this.dentistExternalId = null;
        this.sendEndingLettersViaEDI = false;
        this.ediDentistId = '';
      },
      setOptionsValue: function(value) {
        this.$refs.userNameRow.setValue(value);
        this.$refs.firstNameRow.setValue(value);
        this.$refs.lastNameRow.setValue(value);
        this.$refs.emailRow.setValue(value);
        this.$refs.phoneRow.setValue(value);
        this.$refs.mobileRow.setValue(value);
        this.$refs.statusRow.setValue(value);
        this.$refs.isSecretaryRow.setValue(value);
        this.$refs.dentistExternalIdRow.setValue(value);
        this.$refs.sendEndingLettersViaEDIRow.setValue(value);
        this.$refs.ediDentistIdRow.setValue(value);
      },
      resetOptionValue: function(ref) {
        this.$refs[ref].setValue(null);
      },
      cancelMerge: function() {
        this.resetData();
        this.$emit('closeMergeDialog');
      },
      queryData: function() {
        let queryBody = {};
        queryBody.firstName = this.firstName;
        queryBody.lastName = this.lastName;
        queryBody.email = this.email;
        this.phone && (queryBody.phone = this.phone);
        this.mobilePhone && (queryBody.mobilePhone = this.mobilePhone);
        queryBody.status = this.status;
        methods.isBoolean(this.isSecretary) && (queryBody.isSecretary = this.isSecretary);
        this.dentistExternalId && (queryBody.dentistExternalId = this.dentistExternalId);
        methods.isBoolean(this.sendEndingLettersViaEDI) && (queryBody.sendEndingLettersViaEDI = this.sendEndingLettersViaEDI);
        this.ediDentistId && (queryBody.ediDentistId = this.ediDentistId);
        queryBody.dentistIdToKeep = this.mergeData.filter(mergeItem => mergeItem.userName === this.userName)[0]?.userId;
        queryBody.dentistIdsToMerge = this.mergeData
          .filter(mergeItem => mergeItem.userName !== this.userName)
          .map(mergeItem => mergeItem.userId);

        return queryBody;
      },
      saveMerge: async function() {
        this.$refs.mergeForm.validate();
        if (!this.formValid) return;
        try {
          this.mergeLoading = true;
          await api.mergeUsers(this.queryData());
          let newClinicsData = await api.getUsers({...this.queryParams, ...this.filterParams});
          this.mergeLoading = false;
          this.$emit('updateUsersData', newClinicsData.data);
          this.$emit('clearMerge');
          this.$emit('closeMergeDialog');
          this.$emit('moveToControls');
        } catch (e) {
          this.mergeLoading = false;
        }
      }
    }
  };
</script>

